import { ButtonProps } from '../../../buttons/Button/Button.types';
import { Button } from '../../../buttons/Button/Button';
import { cn } from '@gettactic/helpers';

export const SelectButton = ({
  children,
  className,
  isAccent,
  ...props
}: ButtonProps & {
  isAccent?: boolean;
}) => {
  return (
    <Button
      key="transparent-custom"
      variant="transparentInvisible"
      font={isAccent ? 'boldBrand' : 'boldLowContrast'}
      size="sm"
      layout="normal"
      className={cn('font-medium text-muted-foreground/60 uppercase', className)}
      {...props}
    >
      {children}
    </Button>
  );
};
